import { render, staticRenderFns } from "./customer-info.vue?vue&type=template&id=0c3ac1da&scoped=true"
import script from "./customer-info.vue?vue&type=script&lang=ts"
export * from "./customer-info.vue?vue&type=script&lang=ts"
import style0 from "./customer-info.vue?vue&type=style&index=0&id=0c3ac1da&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3ac1da",
  null
  
)

export default component.exports